import { Box, Typography } from "@mui/material";

export default function NotFound() {
  return (
    <Box
      className="not-found"
      sx={{
        position: "fixed",
        zIndex: 4,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        background: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box className="image-container"></Box>
      <Typography>Data Not Available</Typography>
      <Typography component="span">We couldn't find the page you were looking for.</Typography>
    </Box>
  );
}
